module.exports = __webpack_public_path__ + "img/colaparo.7676cd7f.jpg";